import {textFilterParamsValues} from "../reactTableController";
import AwInputCheckBox from '../../react/AwInputCheckBox';
import { booleanFilterParams, getBooleanValueGetter } from "../../utils/booleanColUtils";

export const defaultSortModel = [
    {
        colId: 'closingDate',
        sort: 'desc',
        sortIndex: 0
    }
];
export const reactStatementsCols = function (translate, filterFormatter, scope) {
    return [ {
        field: "openingDate",
        headerName: translate.instant('OPEN_DATE'),
        sortable: true,
        filter: 'agDateColumnFilter',
        filterParams: {filterOptions: ['equals', 'inRange'], suppressAndOrCondition: true},
        valueGetter: (params) => {
            return params.data ?
                filterFormatter('fsDateNoLocal')( params.data.openingDate) : "";
        }
    },{
        field: "openingBalance",
        headerName: translate.instant('OPEN_BAL'),
        sortable: true,
        filter: 'agNumberColumnFilter',
        valueGetter: (params) => {
            return params.data ?
                filterFormatter('fsNumber')( params.data.openingBalance, scope.fractionDigits) : "";
        },
        type: 'numericColumn'
    }, {
        field: "closingDate",
        headerName: translate.instant('CLOSE_DATE'),
        sortable: true,
        filter: 'agDateColumnFilter',
        filterParams: {filterOptions: ['equals', 'inRange'], suppressAndOrCondition: true},
        valueGetter: (params) => {
            return params.data ?
                filterFormatter('fsDateNoLocal')( params.data.closingDate) : "";
        }
    },{
        field: "closingBalance",
        headerName: translate.instant('CLOSE_BAL'),
        sortable: true,
        filter: 'agNumberColumnFilter',
        valueGetter: (params) => {
            return params.data ?
                filterFormatter('fsNumber')( params.data.closingBalance, scope.fractionDigits) : "";
        },
        type: 'numericColumn'
    },{
        field: "statementNoOrig",
        headerName: translate.instant('STATEMENT_NUMB_ORIGINAL'),
        sortable: true,
        filter: 'agNumberColumnFilter'
    },{
        field: "transactionRefNo",
        headerName: translate.instant('TRANS_REF'),
        sortable: true,
        filter: 'agTextColumnFilter',
        filterParams: textFilterParamsValues
    },{
        field: "f86Bank",
        headerName: translate.instant('INF_TO_ACCOWN'),
        sortable: true,
        filter: 'agTextColumnFilter',
        filterParams: textFilterParamsValues
    },{
        field: "unread",
        headerName: translate.instant('UNREAD'),
        filter: "agSetColumnFilter",
        filterParams: { values: ['UNREAD', 'READ'],
                        valueFormatter: (params) => {
                            return translate.instant(params.value)
                        }},
        cellRenderer: AwInputCheckBox,
        cellRendererParams: {property: 'unread'}
    }, {
        field: "stmtNoAll",
        headerName: translate.instant('STM_CALC_NUMBER1'),
        sortable: true,
        filter: 'agNumberColumnFilter',
        type: 'numericColumn',
        headerTooltip: translate.instant('STM_CALC_NUMBER1_TOOLTIP'),
        initialHide: true
    }, {
        field: "stmtNoNED",
        headerName: translate.instant('STM_CALC_NUMBER2'),
        sortable: true,
        filter: 'agNumberColumnFilter',
        type: 'numericColumn',
        headerTooltip: translate.instant('STM_CALC_NUMBER2_TOOLTIP'),
        initialHide: true
    }, {
        field: "stmtNoOldARS",
        headerName: translate.instant('STM_CALC_NUMBER3'),
        sortable: true,
        filter: 'agNumberColumnFilter',
        type: 'numericColumn',
        headerTooltip: translate.instant('STM_CALC_NUMBER3_TOOLTIP'),
        initialHide: true
    }, {
        field: "camt053",
        headerName: translate.instant('CAMT053'),
        sortable: true,
        filter: 'agSetColumnFilter',
        filterParams: booleanFilterParams('camt053', translate),
        valueGetter: getBooleanValueGetter('camt053', translate, data => data?.camt053),
        initialHide: true
    }];
}
